import React, { useState, useEffect } from 'react';
import { Route, Switch } from "react-router-dom";
import '../common/css/global.css';
import './App.css';
import * as project from "../common/api/projects";
import * as impact from '../common/api/impact';
import ImpactPage from "./pages/ImpactPage";
import merchantLogo from './media/MAG_EMA_FLAT_REV_RGB.png';
import MagEmaStnLandingPage from "../airport-mag/pages/MagEmaStnLandingPage";

function App() {
  const merchantCode = 'AIRPORT_EMA';
  const [fetchedImpact, setFetchedImpact] = useState();

  const quoteData = {
    name: 'Clare James',
    position: 'Managing Director, East Midlands Airport',
    text: <>Our partnership with CarbonClick works with a number of great projects, so by opting to offset their emissions, passengers travelling from East Midlands Airport can support important climate initiatives in the UK and abroad and reduce CO<sub>2</sub> in our atmosphere</>
  };

  useEffect(() => {
    impact.merchants(merchantCode, "en_GB", ['flightsImpact'] )
      .then(response => response.json())
      .then(body => {
        setFetchedImpact(body)
      })
      .catch(error => {
        setFetchedImpact(error)
      })
  }, []);

  return (
    <>

      <Switch>
        {/* DO NOT DELETE IMPACT - The impact page should always be kept, even if not specified in a design */}
        <Route
          exact
          path={`/impact`}
          key="app-mag-impact"
        >
          <ImpactPage merchantCode={merchantCode} />
        </Route>
        {/* DO NOT DELETE IMPACT - The impact page should always be kept, even if not specified in a design */}
        <Route
          path={`/`}
          key="app-mag-landing"
        >
          <MagEmaStnLandingPage merchantLogo={merchantLogo} fetchedImpact={fetchedImpact} merchantCode={merchantCode} quoteData={quoteData}/>
        </Route>
      </Switch>
    </>
  );
}

export default App;
